import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnSuccess } from '@helpers/product-events';

export const tiktokIntegrationService = {
    getAuthorizeUrl,
    connectIntegration,
    disconnectIntegration,
    connectLocation,
};

function getAuthorizeUrl() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/tiktok/authorize-url`, requestOptions).then(handleResponse);
}

function connectIntegration(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/tiktok/connect-integration`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.IntegrationConnected, { integration: 'tiktok' }));
}

function disconnectIntegration(integrationId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    const query = integrationId ? `?integrationId=${integrationId}` : '';
    return fetch(`${BASE_URL}api/tiktok/disconnect-integration${query}`, requestOptions).then(handleResponse);
}

function connectLocation(locationId, integrationId = null) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({ locationId, integrationId }),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/tiktok:connect`, requestOptions).then(
        handleResponse,
    );
}
